/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_User_GenericInputs */

const es_co2_signup_error_user_generic = /** @type {(inputs: Signup_Error_User_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos crear tu cuenta. Intenta de nuevo.`)
};

/**

* @param {Signup_Error_User_GenericInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_user_generic = /** @type {((inputs?: Signup_Error_User_GenericInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_User_GenericInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_user_generic(inputs)
});